import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'
import { getCampaignLogInsertedParams } from './utils'

const insertCampaignLogs = logs => {
  const input = getCampaignLogInsertedParams(logs)

  return callAuthorizedGraphQLEndpoint(
    `mutation insertCampaignLogs($input: [InsertCampaignLogsInput]) {
      insertCampaignLogs(input:$input){
          success
      }
    }`,
    {
      input,
    },
  )
}

export { insertCampaignLogs }
